export const VALIDATION_CONSTANTS = {
  USER: {
    NAME: {
      MIN_LENGTH: 2,
      MAX_LENGTH: 50,
      PATTERN: /^[a-zA-Z\s-']+$/,
      MESSAGE: {
        REQUIRED: 'Name is required',
        MIN_LENGTH: 'Name must be at least 2 characters',
        MAX_LENGTH: 'Name cannot exceed 50 characters',
        PATTERN: 'Name can only contain letters, spaces, hyphens, and apostrophes',
      },
    },
    EMAIL: {
      MAX_LENGTH: 254, // RFC 5321
      PATTERN: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      MESSAGE: {
        REQUIRED: 'Email is required',
        INVALID: 'Please enter a valid email address',
        MAX_LENGTH: 'Email cannot exceed 254 characters',
      },
    },
    PASSWORD: {
      MIN_LENGTH: 8,
      MAX_LENGTH: 128,
      PATTERN: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{8,}$/,
      MESSAGE: {
        REQUIRED: 'Password is required',
        MIN_LENGTH: 'Password must be at least 8 characters',
        MAX_LENGTH: 'Password cannot exceed 128 characters',
        PATTERN: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
      },
    },
  },
  DAILY_TOTALS: {
    CALLS: {
      MIN: 0,
      MAX: 999,
      MESSAGE: {
        REQUIRED: 'Total calls is required',
        MIN: 'Total calls cannot be negative',
        MAX: 'Total calls cannot exceed 999',
      },
    },
    SALES: {
      MIN: 0,
      MAX: 999,
      MESSAGE: {
        REQUIRED: 'Total sales is required',
        MIN: 'Total sales cannot be negative',
        MAX: 'Total sales cannot exceed 999',
      },
    },
    REVENUE: {
      MIN: 0,
      MAX: 999999.99,
      MESSAGE: {
        REQUIRED: 'Total revenue is required',
        MIN: 'Total revenue cannot be negative',
        MAX: 'Total revenue cannot exceed 999,999.99',
      },
    },
    NOTES: {
      MAX_LENGTH: 500,
      MESSAGE: {
        MAX_LENGTH: 'Notes cannot exceed 500 characters',
      },
    },
  },
  AGENCY: {
    NAME: {
      MIN_LENGTH: 2,
      MAX_LENGTH: 100,
      MESSAGE: {
        REQUIRED: 'Agency name is required',
        MIN_LENGTH: 'Agency name must be at least 2 characters',
        MAX_LENGTH: 'Agency name cannot exceed 100 characters',
      },
    },
    PHONE: {
      PATTERN: /^\+?1?\d{10,14}$/,
      MESSAGE: {
        REQUIRED: 'Phone number is required',
        PATTERN: 'Please enter a valid phone number',
      },
    },
    ADDRESS: {
      MAX_LENGTH: 200,
      MESSAGE: {
        REQUIRED: 'Address is required',
        MAX_LENGTH: 'Address cannot exceed 200 characters',
      },
    },
  },
  COMMON: {
    DATE: {
      MIN_YEAR: 2020,
      MAX_YEAR: new Date().getFullYear() + 1,
      MESSAGE: {
        REQUIRED: 'Date is required',
        INVALID: 'Please enter a valid date',
        FUTURE: 'Date cannot be in the future',
        PAST: 'Date cannot be before 2020',
      },
    },
    ID: {
      PATTERN: /^[a-zA-Z0-9-_]+$/,
      MESSAGE: {
        INVALID: 'Invalid ID format',
      },
    },
  },
} as const;

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID: 'Invalid value',
  MIN_LENGTH: (min: number) => `Must be at least ${min} characters`,
  MAX_LENGTH: (max: number) => `Cannot exceed ${max} characters`,
  MIN_VALUE: (min: number) => `Must be at least ${min}`,
  MAX_VALUE: (max: number) => `Cannot exceed ${max}`,
  PATTERN: 'Invalid format',
  DATE: {
    INVALID: 'Invalid date',
    FUTURE: 'Cannot be in the future',
    PAST: 'Cannot be in the past',
  },
} as const;
